import api from "../index"

const icdRequestsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getIcdRequestsByInvestors: build.query({
      query: ({ id, ...params }) => ({
        url: `/icd-requests/all/${id}`,
        method: "GET",
        params,
      }),
    }),

    icdRequestsApprove: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/icd-requests/approve/${id}`,
        method: "POST",
        body,
      }),
    }),
    icdRequestsReject: build.mutation({
      query: ({ id }) => ({
        url: `/icd-requests/reject/${id}`,
        method: "GET",
      }),
    }),
    icdRequestdetails: build.query({
      query: ({ id }) => ({
        url: `/icd-requests/details/${id}`,
        method: "GET",
      }),
    }),
  }),
})

export const {
  useLazyGetIcdRequestsByInvestorsQuery,
  useIcdRequestsApproveMutation,
  useIcdRequestsRejectMutation,
  useLazyIcdRequestdetailsQuery,
} = icdRequestsApi
